import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import MobileDownloadBar from './components/MobileDownloadBar/MobileDownloadBar';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import AppDetails from './pages/AppDetails/AppDetails';
import theme from './theme';
import './App.css';
import './styles/shared.scss';

function App() {
  // Get the basename for GitHub or Bitbucket Pages
  const getBasename = () => {
    // Extract repository name from package.json homepage or use empty string for local development
    const { homepage } = require('../package.json');
    if (!homepage || homepage === '.') return '';

    // Parse the hostname portion from the homepage URL
    try {
      const url = new URL(homepage);
      const pathSegments = url.pathname.split('/').filter(Boolean);
      return pathSegments.length > 0 ? `/${pathSegments[0]}` : '';
    } catch (e) {
      // If homepage is not a valid URL or is a relative path
      if (homepage.startsWith('/')) return homepage;
      if (homepage === '.') return '';

      // Check if we're running on Bitbucket Pages
      // Bitbucket Pages URLs are typically: https://<username>.bitbucket.io/<repo-name>/
      const bitbucketMatch = window.location.hostname.match(/([^.]+)\.bitbucket\.io/i);
      if (bitbucketMatch) {
        // Get the repository name from the pathname
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        return pathSegments.length > 0 ? `/${pathSegments[0]}` : '';
      }

      return `/${homepage}`;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename={getBasename()}>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/app/:appId" element={<AppDetails />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <MobileDownloadBar />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
